export default "__VITE_ASSET__Bfx5$Zkd__"